(() => {
  angular.module('app').component('clinicPatientTicketHealthScreening', {
    templateUrl: require('./widget.html'),
    controller: ClinicPatientTicketHealthScreening,
    controllerAs: 'vm',
    bindings: {
      isDisabled: '<',
      isExpanded: '=',
      isCompleted: '<',
      onDirtyEvent: '<',
      onSetPristineEvent: '<',
      isCreate: '<',
      treatments: '<',
      ticket: '<',
      onComplete: '&',
      currencyCode: '<',
      countryCode: '<',
      isApplyTax: '<',
    },
  });

  ClinicPatientTicketHealthScreening.$inject = ['Hms.PatientTickets.PatientTicketItem'];

  function ClinicPatientTicketHealthScreening(constsPatientTicketItem) {
    const vm = this;

    vm.hasGPTicketEnhancement = abp.setting.getBoolean('Hms.Feature.GPTicketEnhancement');

    vm.isCreate = !vm.ticket.id;
    vm.constsPatientTicketItem = constsPatientTicketItem;
    vm.totalGrossAmount = 0;
    vm.totalTaxAmount = 0;
    vm.totalTreatmentAmount = 0;

    vm.$onChanges = onChanges;
    vm.onDirtyEventHandler = onDirtyEventHandler;
    vm.onSetPristineEventHandler = onSetPristineEventHandler;
    vm.checkDuplicateTreatment = checkDuplicateTreatment;
    vm.updateTreatment = updateTreatment;
    vm.calculateTotalAmount = calculateTotalAmount;
    vm.addTreatments = addTreatments;
    vm.clearTreatments = clearTreatments;
    vm.removeTreatment = removeTreatment;
    vm.next = next;

    init();

    function init() {
      calculateTotalAmount();

      // HACK: HM-10567 - Add "Health screening" treatment option for auto select.

      if (vm.isCreate && vm.ticket && !vm.ticket.hasSaveDraft) {
        const healthScreeningTreatment = _.find(vm.treatments, ['displayName', 'Health screening']);
        vm.ticket.treatments = [
          {
            isUncovered: false,
            prescriptions: [{}],
            treatmentId: healthScreeningTreatment.id,
            treatment: healthScreeningTreatment,
          },
        ];
      }
    }

    function onChanges(changes) {
      if (changes.onDirtyEvent && changes.onDirtyEvent.currentValue) {
        vm.onDirtyEvent.handler = vm.onDirtyEventHandler;
      }

      if (changes.onSetPristineEvent && changes.onSetPristineEvent.currentValue) {
        vm.onSetPristineEvent.handler = vm.onSetPristineEventHandler;
      }
      
      calculateTotalAmount();
    }

    function onDirtyEventHandler() {
      return vm.healthScreeningForm.$dirty;
    }

    function onSetPristineEventHandler() {
      vm.healthScreeningForm.$setPristine();
    }

    function checkDuplicateTreatment(treatment) {
      return _.some(vm.ticket.treatments, { treatmentId: treatment.id });
    }

    function updateTreatment(ticketTreatment) {
      // Validate whether treatment is covered.

      if (ticketTreatment.treatmentId) {
        const treatment = _.find(vm.treatments, { id: ticketTreatment.treatmentId });
        ticketTreatment.isUncovered = treatment.notCovered;
        ticketTreatment.treatment = treatment;
      }

      calculateTotalAmount();
    }

    function calculateTotalAmount() {
      let grossAmount = 0;
      let treatmentAmount = 0;

      _.each(vm.ticket.treatments, (t) => {
        treatmentAmount += t.amount || 0;

        if (vm.isApplyTax && vm.ticket.taxPercentage) {
          grossAmount += t.amount / (1 + vm.ticket.taxPercentage / 100) || 0;
        } else {
          grossAmount += t.amount || 0;
        }
      });

      vm.totalGrossAmount = App.evenRound(grossAmount, 2);
      vm.totalTaxAmount = App.evenRound(treatmentAmount - grossAmount, 2);
      vm.totalTreatmentAmount = App.evenRound(treatmentAmount, 2);
    }

    function addTreatments() {
      vm.ticket.treatments.push({});
    }

    function clearTreatments() {
      vm.ticket.treatments = [{}];
    }

    function removeTreatment(index) {
      if (index < vm.ticket.treatments.length) vm.ticket.treatments.splice(index, 1);
      if (vm.ticket.treatments.length === 0) vm.ticket.treatments = [{}];
    }

    function next() {
      if (App.isFormValid(vm.healthScreeningForm)) {
        vm.onComplete();
      }
    }
  }
})();
